import { Building, Trash2, UploadCloud } from 'lucide-react';
import React, { useRef, useState } from 'react'
import { toast } from '../NewUI/NewComponents/toastService';
import { errors } from '@sideway/address';

const LogoUpload = () => {
const [logoFile, setLogoFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
    
  // Drag and Drop Logo Handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      processLogoFile(files[0]);
    }
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      processLogoFile(files[0]);
    }
  };

  const processLogoFile = (file) => {
    if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
      const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
      if (parseFloat(sizeMB) > 2) {
        toast('Error: Logo file size exceeds 2MB limit',"error");
        return;
      }
      setLogoFile({
        name: file.name,
        size: `${sizeMB} MB`,
        url: URL.createObjectURL(file)
      });
      toast('Logo uploaded successfully!', "success");
    } else {
      toast('Error: Invalid file format. Only PNG, JPG, JPEG are supported.', "error");
    }
  };

  const removeLogo = (e) => {
    e.stopPropagation();
    setLogoFile(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
    toast('Logo removed', "info");
  };
  return (
<div id="setting-logo-upload" className="tw-py-5 last:tw-pb-0 tw-flex tw-flex-col md:tw-flex-row tw-items-stretch md:tw-items-center tw-justify-between tw-gap-4">
  <div className="tw-flex tw-items-center tw-gap-3.5 tw-text-left tw-shrink-0">
    <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-indigo-50 tw-text-indigo-600 tw-flex tw-items-center tw-justify-center tw-shrink-0">
      <Building size={18} />
    </div>
    <div>
      <span className="tw-text-sm tw-font-extrabold tw-text-slate-800 tw-block">Logo Upload</span>
      <span className="tw-text-[11px] tw-text-slate-400 tw-font-medium tw-block">
        Upload your company logo
      </span>
    </div>
  </div>

  {/* Dropzone field */}
  <div
    id="logo-drag-dropzone"
    onDragOver={handleDragOver}
    onDragLeave={handleDragLeave}
    onDrop={handleDrop}
    onClick={() => fileInputRef.current?.click()}
    className={`tw-flex-1 tw-max-w-sm tw-border-2 tw-border-dashed tw-rounded-2xl tw-p-4 tw-flex tw-flex-col tw-items-center tw-justify-center tw-transition-all tw-cursor-pointer ${
      logoFile
        ? 'tw-border-emerald-250 tw-bg-emerald-50/20'
        : isDragging
          ? 'tw-border-indigo-500 tw-bg-indigo-50/30'
          : 'tw-border-slate-200 tw-bg-slate-50/40 hover:tw-bg-slate-50'
    }`}
  >
    <input
      type="file"
      ref={fileInputRef}
      onChange={handleFileSelect}
      accept=".png,.jpg,.jpeg"
      className="tw-hidden"
    />

    {logoFile ? (
      <div
        className="tw-flex tw-items-center tw-justify-between tw-w-full tw-px-2"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          <img
            src={logoFile.url}
            alt="Logo preview"
            className="tw-w-10 tw-h-10 tw-object-contain tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-shadow-xs tw-p-1"
            referrerPolicy="no-referrer"
          />
          <div className="tw-text-left">
            <span className="tw-text-[11px] tw-font-black tw-text-slate-800 tw-block tw-max-w-[150px] tw-truncate tw-leading-tight">
              {logoFile.name}
            </span>
            <span className="tw-text-[9px] tw-text-slate-400 tw-font-bold tw-block">
              {logoFile.size}
            </span>
          </div>
        </div>

        <button
          onClick={removeLogo}
          className="tw-p-2 tw-text-slate-400 hover:tw-text-rose-600 hover:tw-bg-slate-100 tw-rounded-xl tw-transition-all tw-cursor-pointer"
          title="Delete uploaded Logo"
        >
          <Trash2 size={15} />
        </button>
      </div>
    ) : (
      <div className="tw-space-y-1.5 tw-text-center">
        <UploadCloud size={20} className="tw-mx-auto tw-text-slate-400" />
        <div>
          <p className="tw-text-xs tw-font-bold tw-text-slate-700">
            Click to upload
          </p>
          <p className="tw-text-[9px] tw-text-slate-400 tw-font-bold">
            PNG, JPG up to 2MB
          </p>
        </div>
      </div>
    )}
  </div>
</div>
  )
}

export default LogoUpload